import { createWidgetScript } from '../common.js';

/* eslint-disable prefer-destructuring */
function embedWidget() {
  const product = window['vw-product-id'];

  const hasWidgetEntries = !!document.querySelector('[vw-widget]') || !!document.querySelector('[vw-showcase]');
  console.debug(`vestico: has widget entries ${hasWidgetEntries}`);
  console.debug(`vestico: product ${product}`);

  if (!product) {
    if (!hasWidgetEntries) {
      console.info(`vestico: Not a product page and no showcase: ${window.location.pathname}`);

      return;
    }
  }

  createWidgetScript();

  const shop = window.location.hostname;
  // skipcq JS-0125
  _hw('init', {
    buttonClass: 'vestico-widget',
    clientId: shop,
    products: product ? [{ productUID: `${product}`, isTag: false }] : undefined,
    styles: { coreColor: '#303030' },
    isPreview: false,
    isShowcase: true,
    language: document.documentElement.lang,
  });
}

if (document.readyState === 'loading') {
  // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', embedWidget);
} else {
  // `DOMContentLoaded` has already fired
  embedWidget();
}
